<template>
  <!-- 开票详情 -->
  <div class="invoice-detail">
        <div class="billingMoney">
            <h3>开票金额</h3>
            <el-row>
                <el-col :span="8">
                    <div>开票金额</div>
                    <p>{{ $filters.formatMoney(dataForm.invoiceAmount)}} <span>(CNY)</span></p>
                </el-col>
                <el-col :span="8">
                    <div>税率</div>
                    <p>{{dataForm.taxRate ? dataForm.taxRate + '%' : ''}}</p>
                </el-col>
                <el-col :span="8">
                    <div>税额</div>
                    <p>{{ $filters.formatMoney(dataForm.tax)}} <span>(CNY)</span></p>
                </el-col>
            </el-row>
        </div>

        <div class="invoice-herder">       
            <h3>发票抬头</h3>
            <div class="supplierName">
                <div class="supplier"> 开票名称</div>
                <p>{{customerVo.billName}}</p>
                <div class="name">纳税人识别号：<span>{{customerVo.taxpayerCode}}</span></div>
            </div>
            <el-row>
                <el-col :span="8">开户银行：<span>{{customerVo.billBank}}</span></el-col>
                <el-col :span="8">银行账号：<span>{{customerVo.billBankAcct}}</span></el-col>
                <el-col :span="8">联系电话：<span>{{customerVo.billTel}}</span></el-col>
                <el-col :span="8">收票联系人：<span>{{customerVo.receiptInvoicePerson}}</span></el-col>
                <el-col :span="8">电话：<span>{{customerVo.receiptInvoiceTel}}</span></el-col>
                <el-col :span="8">收票地址：<span>{{customerVo.receiptInvoiceAddress}}</span></el-col>
                <el-col :span="8">开票地址：<span>{{customerVo.billAddress}}</span></el-col>
            </el-row>
        </div> 

        <div class="billingMoney-table">
            <div class="title">
                <h3>开票金额</h3>
                <el-button :loading='loading' @click="exportFile">导出</el-button>
            </div>

            <ab-table
                class="materialTable"
                stripe
                ref="table"
                selectionWidth="45"
                indexWidth="80"
                showMoreEdit
                widths="140"
                :column-list="columns"
                :table-list="tableData"
                :dataListLoading="isloading"
                :headerCellClassName='must'
                :showSummary="true"
                :summary-method="(param)=>getSummaries1(param,['invoiceCount','notTaxAmount','tax','taxAmount'])"
            >
                <template #taxRate = "scope">
                    {{scope.row.taxRate}}%
                </template>
            </ab-table>
        </div>

        <ab-footer>
            <el-button type="primary"  :loading="confirmLoading" @click="confirmSave" v-if="dataForm.clientStatus === '01-1'">修 改</el-button>
            <el-button @click="backListPage">返回</el-button>
        </ab-footer>     

         <!-- 标签 -->
        <div class="number">
            <div class="text">NO：<span>{{dataForm.number}}</span></div>
            <div class="time">{{dataForm.createTimeDesc}}</div>
        </div>
        <ab-preview :preview="preview" @handleClose="handleClose">
            <template #button>
                <el-button @click="preview.show = false">关 闭</el-button>
            </template>
        </ab-preview>
  </div>
</template>

<script>
export default {
    name: 'invoice-detail',
    data() {
        return {
            id:'',
            columns: [
                {
                  props: "custOrderNo",
                  labels: "订单编号",
                  widths: 100,
                  sort: "custom",
                },
                {
                  props: "materialDesc",
                  labels: "开票名称",
                  widths: 100,
                },
                {
                  props: "model",
                  labels: "规格型号",
                  widths: 130,
                },
                {
                  props: "unitIdDesc",
                  labels: "单位",
                  widths: 80,
                },
                {
                  props: "invoiceCount",
                  labels: "数量",
                  widths: 70,
                },
                {
                  props: "notTaxAmount",
                  labels: "不含税金额",
                  widths: 90,
                  type:'money',
                  align: "right",
                },
        
                {
                  props: "tax",
                  labels: "税额",
                  widths: 100,
                  type:'money',
                  align: "right",
                },
                {
                  props: "taxAmount",
                  labels: "价税合计",
                  widths: 100,
                  type:'money',
                  align: "right",
                },
        
                {
                  props: "taxRate",
                  labels: "税率",
                  widths: 80,
                  slot:'slot',
                  align: "center",
                },
            ],
            tableData: [],
            //基础信息
            dataForm:{},
            //银行信息
            customerVo: {},
            loading:false,
            isloading:false,
            routeQuery: {},
            confirmLoading: false,
            preview: {
                show: false,
                isView: false,
                isFooter: true,
                fileUrl: ''
            }
        }
    },
    computed: {
        mainTabs: {
            get() {
                return this.$store.state.mainTabs
            },
            set(val) {
                this.$store.commit('updateMainTabs', val)
            }
        },
        mainTabsActiveName: {
            get () { return this.$store.state.mainTabsActiveName },
            set (val) { this.$store.commit('updateMainTabsActiveName', val) }
        },
    },
    methods:{
        //表格合计
        getSummaries1(param,value) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
            if (index === 0) {
                sums[index] = '合计';
                return;
            }
            let val= value.indexOf(column.property) != -1
            if(val){
                const values = data.map(item => Number(item[column.property]))
                sums[index]= values.reduce((prev, curr) => {
                    const value = Number(curr)
                    if (!isNaN(value)) {
                            return this.$calc.add(prev, curr)
                        } else {
                            return prev
                        }
                }, 0)
                if (column.property != 'invoiceCount') {
                    sums[index] = this.$filters.formatMoney(sums[index])
                }
            }
            });
            return sums;
        },



        getSummaries(param) {
            console.log(param);
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                const values = data.map(item => Number(item[column.property]));
                if (["invoiceCount", "notTaxAmount", "tax", "taxAmount"].includes(column.property)) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return calc.add(prev, curr);
                        } else {
                            return prev;
                        }
                    }, 0);
                if (column.property !== "invoiceCount") {
                    sums[index] = Vue.filter("formatMoney")(sums[index]);
                }
                } else {
                    sums[index] = "";
                }
            });
            return sums;
        },
        //表头心号
        must(obj){
            if(['invoiceCount'].indexOf(obj.column.property) !== -1) {
                return 'must';
            }
        },
        //请求获取数据
        getDetailData(){
            this.isloading=true
            this.$get("/fms/drawInvoice/get", { id:this.routeQuery.id }).then(({ data }) => {
                if (data && data.code === "C0000") {
                    let result = data.result || {};
                    this.dataForm = result;
                    this.customerVo = result.customerVo || {};
                    if (result.invoiceTypeDesc && result.invoiceTypeDesc === "货值发票") {
                        this.tableData = result.drawInvoiceEntryVos || [];
                    } else {
                        this.tableData = result.mergeVos || [];
                    }
                }else{
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }  
            }).finally(() => {
                this.isloading=false
            });
        },
        //导出
        exportFile() {
            this.loading=true
            let params = {}
            let excelField = this.columns.map(e => e.props);            
            params.mergeDtos = this.tableData            
            params.excelField= excelField
            params.data= {id: this.routeQuery.id}            
            this.$post("/fms/client/drawInvoice/deriveDrawInfo",params).then(({ data }) => {
                if (data && data.code === "C0000") {
                    // 创建隐藏的可下载链接
                    var eleLink = document.createElement("a");
                    eleLink.download = "";
                    eleLink.target = "_blank";
                    eleLink.style.display = "none";
                    // 字符内容转变成blob地址
                    eleLink.href = data.message;
                    // 触发点击
                    document.body.appendChild(eleLink);
                    eleLink.click();
                    // 然后移除
                    document.body.removeChild(eleLink);
                } else {
                    this.$message({type: 'error', message: data.message, offset: 380, grouping: true})
                }
            }).finally(() => {
                this.loading=false
            });
        },
        //返回
        backListPage(){
            window.history.back()
        },
        confirmSave() {
            let dataForm = this.$_.cloneDeep(this.dataForm)
            let detailData = {
                drawInvoiceEntryVos: dataForm.drawInvoiceEntryVos,
                customerVo: dataForm.customerVo
            }
            delete dataForm.drawInvoiceEntryVos
            delete dataForm.customerVo
            detailData.result = dataForm
            window.sessionStorage.removeItem('detailData')
            window.sessionStorage.setItem('detailData',JSON.stringify(detailData))
            this.deletePage()
        },
        handleClose () {
            this.getDetailData()
        },
        deletePage () {
            this.removeTabHandle(this.mainTabsActiveName);
        },
        removeTabHandle(tabName) {
            console.log(tabName)
            this.mainTabs = this.mainTabs.filter(item => item.index !== tabName)
            this.$router.push({path: '/invoice-add'})
        },
    },
    created(){},
    activated(){
        let query = this.$route.query || {}
        this.routeQuery = Object.keys(query).length ? query : this.routeQuery
        if (
            typeof this.routeQuery.cache === "string"
                ? JSON.parse(this.routeQuery.cache)
                : this.routeQuery.cache
        ) {
            return false
        } else {
            this.routeQuery.cache = true
        }
        this.getDetailData()
    }
}
</script>

<style lang="scss">
.invoice-detail{
    .footers{
        position: fixed;
        bottom: 42px;
        padding: 20px !important;
        width: calc(100% - 88px);
        left: 40px;
        background-color: #fff;
        z-index: 22;
        bottom: 41px;
    }
    position: relative;
    padding:40px 0 10px 0;
    text-align: left;
    color: #000000;
    .el-table th.must>.cell:after {
	    content: ' *';
	    color: #ff1818;
    }
    h3{
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 40px;
    }
    .billingMoney{
        padding-bottom: 40px;
        margin-bottom: 40px;
        border-bottom: 1px solid #f0f2f5;
        .el-col.el-col-8{
            div{
                font-size: 14px;
                margin-bottom: 5px;
            }
            p{
                font-size: 36px;
                color: #F87243;
                font-weight: 500;
                font-family: DIN_Condensed_Bold;
                span{
                    font-size: 14px;
                }
            }
        }
    }
    .invoice-herder{
        border-bottom: 1px solid #f0f2f5;
        margin-bottom: 27px;
        .supplierName{
            width: 100%;
            display: flex;
            padding: 0 0 20px;
            margin-bottom: 20px;
            border-bottom: 1px solid #F0F2F5;
            line-height: 24px;              
            .supplier{
                padding: 5px 10px;
                height: 24px;
                line-height: 14px;
                border-radius: 4px;
                font-size: 14px;
                background-color: #F0F2F5;
            }
            p{
                font-size: 22px;
                font-weight: bold; 
                margin-left: 20px;                   
            }
            .name{
                margin-left: 20px;
                font-size: 14px;
                color: #F87243;
            }
        }
        .el-row{
            font-size: 14px;
            .el-col{
                margin-bottom:30px ;
            }
            .el-col.el-col-24{
                margin-bottom:40px ;
            }
            
        }
    }
    .billingMoney-table{
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 27px;
            h3{
                margin: 0;
            }
        }
        .el-table__footer-wrapper{
            td{
                background-color: #F2f7ff;
            }
        }
    }
    .footers {
        text-align: center;
        margin: 20px 0 0;
        padding: 20px 0 0;
        border-top: 1px solid #F0F2F5;
    }


    //标签
    .number{
        position: absolute;
        width: 200px;
        top: 0px;
        right: 0px;
        border-radius: 0 0 8px 8px;
        background-color:#F2F7FF ;
        font-size: 14px;
        text-align: center;
        font-family: Microsoft YaHei;;
        .text{
            padding: 10px 0;
            border-bottom: 1px solid #F0F2F5;
        }
        .time{
            padding: 10px 0;
        }
    }
}

</style>